import { PopularArticleItem } from './cms-popular-article-item.interface';

export interface PopularArticles {
  popularArticlesTitle: string;
  popularArticles: PopularArticleItem[];
}
